"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const remove_1 = tslib_1.__importDefault(require("lodash/remove"));
const uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
const command_1 = require("../../type/command");
const entity_1 = require("../../type/entity");
const getVersionIdOfContent_1 = tslib_1.__importDefault(require("../versions/getVersionIdOfContent"));
const getContentStatus_1 = tslib_1.__importDefault(require("./getContentStatus"));
const getDueDate_1 = require("./getDueDate");
const getEnrolmentAssignInfo_1 = tslib_1.__importDefault(require("./getEnrolmentAssignInfo"));
function getEnrolmentInfo(command, content, enrolment) {
    const enrolmentInfoObject = getEnrolmentAssignInfo_1.default(command, content);
    return [...enrolment.enrolmentInfo, enrolmentInfoObject];
}
const getParentIdsFromCommand = (command, content) => {
    return command.rootContentId !== content._id ? [command.rootContentId] : [];
};
function addParentIds(command, content, enrolment) {
    const assignedViaParentIds = getParentIdsFromCommand(command, content);
    const finalParentIds = uniq_1.default((enrolment.parentIds || []).concat(assignedViaParentIds));
    if (finalParentIds.length !== (enrolment.parentIds || []).length) {
        enrolment.parentIds = finalParentIds;
    }
}
function removeParentIds(command, content, enrolment) {
    const deAssignedParentIds = getParentIdsFromCommand(command, content);
    remove_1.default(enrolment.parentIds || [], parentId => deAssignedParentIds.indexOf(parentId) !== -1);
}
exports.removeParentIds = removeParentIds;
function updateParentIds(command, content, enrolment) {
    switch (command.type) {
        case command_1.CommandType.ASSIGN_CONTENT:
            addParentIds(command, content, enrolment);
            break;
        case command_1.CommandType.DEASSIGN_CONTENT:
            removeParentIds(command, content, enrolment);
            break;
        default:
    }
}
exports.updateParentIds = updateParentIds;
function updateContentStatus(enrolment, content) {
    const contentStatus = getContentStatus_1.default(content);
    enrolment.contentStatus = contentStatus;
}
exports.updateContentStatus = updateContentStatus;
function getExistingEnrolmentInfo(command, enrolment) {
    const { assignmentEventId, timeStamp } = command;
    const existingEnrolmentInfo = enrolment.enrolmentInfo.find(currentEnrolmentInfo => {
        // if content is assigned via any assignment,
        // then we need to check whether assignment has been assigned with same assignment
        if (assignmentEventId) {
            const isAssignedWithSameAssignmentEventId = currentEnrolmentInfo.assignmentEventId === assignmentEventId;
            return isAssignedWithSameAssignmentEventId;
        }
        // If content is not assigned via any assignment, enrolment info should be checked on assigned date
        return new Date(currentEnrolmentInfo.assignDate).getTime() === new Date(timeStamp).getTime();
    });
    return existingEnrolmentInfo;
}
function updateEnrolmentInfo(command, enrolment, content) {
    const { assignType } = command;
    if (assignType === entity_1.AssignType.ENROLLED && !enrolment.deleted) {
        // If content is already assigned i.e. deleted is false then that content can't be enrolled via that user
        return;
    }
    const existingEnrolmentInfo = getExistingEnrolmentInfo(command, enrolment);
    if (!existingEnrolmentInfo) {
        const enrolmentInfo = getEnrolmentInfo(command, content, enrolment);
        enrolment.enrolmentInfo = enrolmentInfo;
    }
}
exports.updateEnrolmentInfo = updateEnrolmentInfo;
function updateDates(command, enrolment) {
    const { timeStamp } = command;
    enrolment.updatedAt = timeStamp;
}
exports.updateDates = updateDates;
function setDirectFlag(enrolment, direct) {
    enrolment.direct = direct;
}
function updateDirectEnrolment(command, enrolment) {
    switch (command.type) {
        case command_1.CommandType.ASSIGN_CONTENT:
            setDirectFlag(enrolment, true);
            break;
        case command_1.CommandType.DEASSIGN_CONTENT:
            setDirectFlag(enrolment, false);
            break;
        default:
    }
}
exports.updateDirectEnrolment = updateDirectEnrolment;
function updateApproverInfoInEnrolment(enrolment, unitSettings) {
    let reviewerSettings;
    let reviewerType;
    if (unitSettings) {
        reviewerSettings = unitSettings.reviewerSettings || {};
        reviewerType = reviewerSettings.reviewerType;
    }
    switch (reviewerType) {
        case entity_1.ReviewerType.USER:
        case entity_1.ReviewerType.GROUP:
            const userTypeApproverSetting = reviewerSettings;
            if (userTypeApproverSetting.reviewerIds || enrolment.reviewerIds) {
                enrolment.reviewerIds = userTypeApproverSetting.reviewerIds;
            }
            enrolment.reviewerType = userTypeApproverSetting.reviewerType;
            break;
        case entity_1.ReviewerType.MANAGER:
            enrolment.reviewerType = entity_1.ReviewerType.MANAGER;
            break;
        case entity_1.ReviewerType.NONE:
        default:
            enrolment.reviewerType = entity_1.ReviewerType.NONE;
            break;
    }
    return enrolment;
}
exports.updateApproverInfoInEnrolment = updateApproverInfoInEnrolment;
const undeleteEnrolment = (enrolment) => (enrolment.deleted = false);
const deleteEnrolment = (enrolment) => (enrolment.deleted = true);
function updateDeletedInEnrolment(command, enrolment) {
    switch (command.type) {
        case command_1.CommandType.ASSIGN_CONTENT:
            undeleteEnrolment(enrolment);
            break;
        case command_1.CommandType.DEASSIGN_CONTENT:
            if ((enrolment.parentIds || []).length === 0 && enrolment.direct === false) {
                deleteEnrolment(enrolment);
            }
            break;
        default:
    }
}
exports.updateDeletedInEnrolment = updateDeletedInEnrolment;
function updateVersionIdOfEnrolment(versions, content, enrolment) {
    try {
        const versionId = getVersionIdOfContent_1.default(versions, content._id);
        const previousVersionId = enrolment.versionId;
        if (versionId || previousVersionId) {
            enrolment.versionId = versionId || previousVersionId;
        }
    }
    catch (error) {
        throw error;
    }
}
exports.updateVersionIdOfEnrolment = updateVersionIdOfEnrolment;
function updateDueDateInEnrolment(command, enrolment) {
    const { dueDateDetails } = command;
    const lastAssignInfoIndex = enrolment.enrolmentInfo.length - 1;
    const assignInfo = enrolment.enrolmentInfo[lastAssignInfoIndex];
    if (dueDateDetails.type === entity_1.DueDateType.CONTENT_DEPENDENT) {
        const newDueDate = getDueDate_1.getDueDateFromType(command, dueDateDetails, dueDateDetails.timeStamp || '-1');
        assignInfo.dueDate = newDueDate;
    }
    else {
        const newDueDate = getDueDate_1.getDueDateFromType(command, dueDateDetails, assignInfo.dueDate);
        assignInfo.dueDate = newDueDate;
    }
    enrolment.enrolmentInfo[lastAssignInfoIndex] = assignInfo;
}
exports.updateDueDateInEnrolment = updateDueDateInEnrolment;
//# sourceMappingURL=updateEnrolmentFields.js.map